<div class="loader-container" *ngIf="isLoading">
    <div class="loader"></div>
</div>

<div *ngIf="!isLoading">
    <app-title [country]="country" [cpaCode]="cpa" [cpaName]="cpaName" [locale]="locale"></app-title>

    <div class="flex-container">
        <div class="flex-row breadcrumb font-color-grey row-1">
            <span>
                <a routerLink="/dashboard" queryParamsHandling="merge">
                    {{ 'T1' | translate : locale }}
                </a>
            </span>
            <span class="breadcrumb-arrow">></span>
            <span>{{ 'T4' | translate : locale }}</span>
        </div>

        <div class="flex-row ag-theme-material border-bottom-black row-2">
            <ag-grid-angular style="height: 100%; width: 100%;" [gridOptions]="gridOptions" [rowData]="events | async">
            </ag-grid-angular>
        </div>

        <div class="flex-row row-3">
            <div class="flex-row-item">
                <span [innerHTML]="'T33' | translate : locale : placeholders"
                    *ngIf="allRowCount === displayedRowCount"></span>
                <span [innerHTML]="'T33a' | translate : locale : placeholders"
                    *ngIf="allRowCount !== displayedRowCount"></span>
            </div>
            <div class="flex-row-item font-color-grey">
                <span>
                    {{ 'T34' | translate : locale : placeholders }}
                </span>
            </div>
        </div>
    </div>

</div>